// IE 11 polyfill
import 'core-js/shim';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import App from './containers/App';
import GravityFormsProvider from './containers/GravityForms';
import store, { history } from './services/ReduxStore';
import registerServiceWorker from './registerServiceWorker';
import { I18nextProvider } from "react-i18next";
import i18n from './services/i18n';

import './App.css';

const target = document.getElementById('root');

render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<I18nextProvider i18n={i18n}>
				<GravityFormsProvider>
					<App />
				</GravityFormsProvider>
			</I18nextProvider>
		</ConnectedRouter>
	</Provider>,
	target
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js